<template>
    <v-row>
        <v-col cols="12" class="pa-0">
            <v-form ref="protocoloEmMassaList">
                <v-data-table
                    dense
                    :headers="headers"
                    :items="list"
                    :item-class="(item) => item.is_editada==true? 'active' : '' "
                    ref="protocoloDataTable"
                    class="protocoloDataTable"
                    hide-default-footer
                >
                    <template v-slot:item.arq_vl_calculado="{ item }">
                        {{ item.arq_vl_calculado | formatPrice }}
                    </template>

                    <template v-slot:item.env_op_protocolo="{ item }">
                        <v-text-field
                            :ref="getRef(item.id, 'env_op_protocolo')"
                            v-model="item.env_op_protocolo"
                            class="input-no-border"
                            style="padding:0 !important; height: 24px"
                            @input="validaItem(item, 'env_op_protocolo')"
                            :rules="(item.env_op_dt_protocolo != null || item.env_op_status_protocolo != null) ? [formRules.requiredField, formRules.max20] :[formRules.requiredField, formRules.max20]"
                        ></v-text-field>
                    </template>

                    <template v-slot:item.env_op_dt_protocolo="{ item }">
                        <v-menu
                            ref="dt"
                            v-model="item.dt"
                            :close-on-content-click="true"
                            transition="scale-transition"
                            offset-y
                            >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                :ref="getRef(item.id, 'env_op_dt_protocolo')"
                                v-model="item.dateFormatted"
                                dense
                                :return-value.sync="item.dateFormatted"
                                v-mask="'##/##/####'"
                                format="DD/MM/YYYY"
                                placeholder="DD/MM/YYYY"
                                class="mt-2 mb-n5"
                                label
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                append-icon="mdi-calendar-blank"
                                @blur="item.env_op_dt_protocolo = parseDate(item.dateFormatted)"
                                :rules="(item.env_op_protocolo != null || item.env_op_status_protocolo != null) ?[formRules.requiredField, formRules.typeDateFormated] :[]"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                color="primary"
                                v-model="item.env_op_dt_protocolo"
                                @input="item.dateFormatted = formatDate(item.env_op_dt_protocolo); validaItem(item, 'env_op_dt_protocolo')"
                                no-title
                                scrollable
                            ></v-date-picker>
                        </v-menu>
                    </template>

                    <template v-slot:item.env_op_status_protocolo="{ item }">
                        <v-select
                            :ref="getRef(item.id, 'env_op_status_protocolo')"
                            v-model="item.env_op_status_protocolo"
                            :items="status"
                            item-text="descricao"
                            item-value="id"
                            flat
                            solo
                            dense
                            outlined
                            :menu-props="{ bottom: true, offsetY: true }"
                            placeholder="Selecione"
                            class="mt-2 mb-n5"
                            @input="validaItem(item, 'env_op_status_protocolo'); markRowSave()"
                            :rules="(item.env_op_dt_protocolo != null || item.env_op_protocolo != null) ?formRules.required : []"
                        ></v-select>
                    </template>

                    <template v-slot:item.erro_protocolo="{ item }">
                        <v-text-field
                            v-if="item.env_op_status_protocolo == '1' || item.env_op_status_protocolo == '4'"
                            :ref="getRef(item.id, 'erro_protocolo')"
                            v-model="item.erro_protocolo"
                            class="input-no-border"
                            style="padding:0 !important; height: 24px"
                            placeholder="Erro acusado pela operadora"
                            @input="validaItem(item, 'erro_protocolo')"
                            :rules="formRules.required"
                        ></v-text-field>
                        <p v-else-if="item.proc_trd_tem_erro">{{ item.erro_protocolo }}</p>
                    </template>

                    <template v-slot:item.desfazer="{ item }">
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }" >
                                <v-btn
                                    x-small 
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mx-1" 
                                > 
                                    <v-icon v-if="item.historico.length==0" x-small>far fa-eye</v-icon>
                                    <v-icon v-else color="primary" x-small @click="historico(item)">far fa-eye</v-icon>
                                </v-btn>
                            </template>
                            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">Histórico</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }" >
                                <v-btn
                                    x-small 
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mx-1" 
                                >   
                                    <v-icon v-if="!dataToSave.filter(el => el.id == item.id).length" x-small>fa-history</v-icon>
                                    <v-icon v-else color="primary" x-small @click="desfazerAlteracoes(item)">fa-history</v-icon>
                                </v-btn>
                            </template>
                            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">Desfazer alteração</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-form>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        disableSaveButton: Function,
        headers: Array,
        list: Array,
        status: Array,
        formRules: Object,
        armazenaItem: Function,
        dataToSave: Array,
        formatDate: Function,
        parseDate: Function,
        desfazerAlteracoes: Function,
        historico: Function,
        validRules: Boolean
    },
    watch: {
        dataToSave(val) {
            if (val) this.markRowSave()
        },
        list(val) {
            if (val) setTimeout(() => {this.markRowSave()}, 10)
        },
        validRules(bool) {
            if (bool) 
                this.$refs.protocoloEmMassaList.validate()
        }
    },
    mounted() {
        this.markRowSave()
    },
    methods: {
        markRowSave() {
            let indOn = this.list.filter(el => el.id == this.dataToSave.map(x => x.id).find(z => z == el.id))
            let indOff = this.list.filter(el => el.id != this.dataToSave.map(x => x.id).find(z => z == el.id))
            indOn.forEach(item => {
                let index = this.list.findIndex(el => el.id == item.id)
                let critica = item.env_op_status_protocolo == '1' || item.env_op_status_protocolo == '4'
                let erroCadastro = item.erro_cadastro ?true :false
                if (index > -1 && !erroCadastro) 
                    this.markRow(true, index, critica)
                if (index > -1 && erroCadastro) 
                    this.markRowErro(true, index, critica)
            })
            indOff.forEach(item => {
                let index = this.list.findIndex(el => el.id == item.id)
                let critica = item.env_op_status_protocolo == '1' || item.env_op_status_protocolo == '4'
                let erroCadastro = item.erro_cadastro
                if (index > -1 && !erroCadastro) 
                    this.markRow(false, index, critica)
                if (index > -1 && erroCadastro) 
                    this.markRowErro(false, index, critica)
            })
        },
        markRow(markLine, index, critica) {
            !markLine && critica
            ? this.$refs[`protocoloDataTable`].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].setAttribute('class', 'critica')
            : markLine
            ? this.$refs[`protocoloDataTable`].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].setAttribute('class', critica ?'act-crit' :'active') 
            : this.$refs[`protocoloDataTable`].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].removeAttribute('class', 'active')
        },
        markRowErro(markLine, index, critica) {
            !markLine && critica
            ? this.$refs[`protocoloDataTable`].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].setAttribute('class', 'critica')
            : markLine
            ? this.$refs[`protocoloDataTable`].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].setAttribute('class', critica ?'act-crit-erro' :'erro-cadastro') 
            : this.$refs[`protocoloDataTable`].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].removeAttribute('class', 'erro-cadastro')
        },
        getRef(id, campo){
            return campo+'_'+ this.list.findIndex(el=>el.id == id)
        },
        validaItem(item, campo){
            let ref = this.getRef(item.id, campo)
            if(this.$refs[ref].validate()){
                this.armazenaItem(item, campo)
                if(this.$refs.protocoloEmMassaList.validate())
                    this.disableSaveButton(false)
            }
            else {
               this.disableSaveButton(true)
            }
        }
    }
}
</script>

<style>
</style>